import { Map, fromJS } from 'immutable'
import { actions } from './actions'

const initialState = Map({
    appLaunchComplete: false,
    loggingIn: false,
    loginError: null,
    loggingInWithFacebook: false,
    facebookLoginError: null,
    facebookLoginResponse: null,
    sendingResetPasswordEmail: false,
    sendResetPasswordError: null,
    sendResetPasswordMessage: null,
    newUserFaceBook: null,
    signOut: false,
    signOutError: null,
    updatedTerms: null,
    updatedPrivacy: null,
    displayTermsModal: false,
    displayPrivacyModal: false,
    feedbackCheckFailed: null,
    tnpUpadteFailed: false,
    tnpUpdateSuccess: false,
    MobileBridgeAppLaunchSuccess: false,
    gettingTokens: false,
    showOTPScreen: false,
    otpData: null,
    mfaAuthError: null,
    authLoading: false,
    mfaResendCodeError: null,
    loggedIn: null,
    isAppRefreshing: false,
})

const authentication = (state = initialState, action) => {
    const { type, payload } = action

    switch (type) {
        case actions.GET_TOKENS_START: {
            return state.set('gettingTokens', true)
        }

        case actions.GET_TOKENS_SUCCESS: {
            return state.merge({
                receivedTokens: fromJS(payload),
                gettingTokens: false,
            })
        }

        case actions.GET_TOKENS_FAILED: {
            return state.merge({
                gettingTokens: false,
            })
        }

        case actions.MOBILE_BRIDGE_APP_LAUNCH_SUCCESS: {
            return state.merge({
                MobileBridgeAppLaunchSuccess: payload,
            })
        }

        case actions.SET_DISPLAY_TnC_MODAL: {
            return state.merge({
                displayTnPModal: false,
            })
        }

        case actions.PATCH_UPDATED_TERMS_AND_PRIVACY: {
            return state.merge({
                updatedTerms: null,
                updatedPrivacy: null,
            })
        }

        case actions.APP_LAUNCH_FINISHED: {
            return state.set('appLaunchComplete', true)
        }

        case actions.SET_UPDATED_TERMS_AND_CONDITIONS: {
            return state.merge({
                displayTermsModal: payload != null,
                updatedTerms: payload,
            })
        }

        case actions.SET_UPDATED_PRIVACY_POLICY: {
            return state.merge({
                displayPrivacyModal: payload != null,
                updatedPrivacy: payload,
            })
        }

        case actions.LOGIN: {
            return state.set('loggingIn', true)
        }

        case actions.LOGIN_SUCCESS: {
            return state.merge({
                loggingIn: false,
                loggedIn: true,
            })
        }

        case actions.LOGIN_FAILED: {
            return state.merge({
                loggingIn: false,
                loginError: fromJS(payload),
            })
        }

        case actions.SIGN_OUT: {
            return state.set('signOut', true)
        }

        case actions.SIGN_OUT_SUCCESS: {
            return state.merge({
                signOut: false,
                loggedIn: null,
            })
        }

        case actions.SIGN_OUT_FAILED: {
            return state.merge({
                signOut: false,
                signOutError: fromJS(payload),
            })
        }

        case actions.AUTH_LOADING: {
            return state.merge({
                authLoading: payload,
            })
        }

        case actions.GET_MFA_RESEND_CODE_FAILED: {
            return state.merge({
                mfaResendCodeError: payload,
            })
        }

        case actions.GET_MFA_AUTH_FAILED: {
            return state.merge({
                mfaAuthError: payload,
            })
        }

        case actions.RESET_MFA_ERROR: {
            return state.merge({
                mfaAuthError: null,
                mfaResendCodeError: null,
            })
        }

        case actions.MFA_AUTH: {
            return state.set('loggingIn', false)
        }

        case actions.OTP_GENERATE_SUCCESS: {
            return state.merge({
                showOTPScreen: payload.success,
                otpData: payload.data,
            })
        }

        case actions.LOGIN_CANCELLED: {
            return state.merge({
                loggingIn: false,
                loginError: null,
            })
        }
        case actions.LOGIN_WITH_FB: {
            return state.merge({
                loggingInWithFbError: null,
                loggingInWithFacebook: true,
            })
        }

        case actions.FACEBOOK_RESPONSE_COMPLETE: {
            return state.merge({
                loggingInWithFacebook: false,
            })
        }

        case actions.FACEBOOK_LOGIN_SUCCESS: {
            return state.merge({
                facebookLoginResponse: fromJS(payload),
                loggingInWithFacebook: false,
            })
        }

        case actions.FACEBOOK_LOGIN_FAILED: {
            return state.merge({
                facebookLoginError: fromJS(payload),
                loggingInWithFacebook: false,
                facebookLoginResponse: null,
            })
        }

        case actions.SEND_PASSWORD_RESET_EMAIL: {
            return state.merge({
                sendPasswordResetEmailError: null,
                sendingPasswordResetEmail: true,
            })
        }

        case actions.RESET_PASSWORD_MESSAGE: {
            return state.merge({
                sendResetPasswordMessage: fromJS(payload),
            })
        }
        case actions.RESET_PASSWORD_SUCCESS: {
            return state.set('sendingResetPasswordEmail', false)
        }

        case actions.RESET_PASSWORD_FAILED: {
            return state.merge({
                sendResetPasswordError: fromJS(payload),
                sendingResetPasswordEmail: false,
            })
        }
        case actions.LOGOUT: {
            return state.set('loggingOut', true)
        }

        case actions.LOGOUT_SUCCESS: {
            return state.merge({
                loginError: null,
                loggingOut: false,
            })
        }

        case actions.LOGOUT_FAILED: {
            return state.set('loggingOut', false)
        }

        case actions.CLEAR_FORM_ERRORS: {
            return state.merge({
                loginError: null,
            })
        }

        case actions.NEW_USER_FACEBOOK: {
            return state.merge({
                newUserFaceBook: fromJS(payload),
            })
        }

        case actions.RESET_NEW_USER_FACEBOOK: {
            return state.merge({
                newUserFaceBook: null,
            })
        }

        case actions.CHECK_ORDER_FEEDBACK_FAILED: {
            return state.merge({
                feedbackCheckFailed: fromJS(payload),
            })
        }

        case actions.PATCH_UPDATED_TERMS_AND_PRIVACY_FAILURE: {
            return state.merge({
                tnpUpadteFailed: payload,
            })
        }

        case actions.PATCH_UPDATED_TERMS_AND_PRIVACY_SUCCESS: {
            return state.merge({
                tnpUpdateSuccess: payload,
            })
        }

        case actions.REFRESH_APP: {
            return state.merge({
                isAppRefreshing: true,
            })
        }

        case actions.REFRESH_APP_SUCCESS: {
            return state.merge({
                isAppRefreshing: false,
            })
        }

        case actions.REFRESH_APP_FAILED: {
            return state.merge({
                isAppRefreshing: false,
            })
        }

        default:
            return state
    }
}

export default authentication
